/*
 * @Descripttion:
 * @version:
 * @Author: mrh
 * @Date: 2019-11-12 15:50:38
 * @LastEditors: mrh
 * @LastEditTime: 2021-01-12 15:29:13
 */
import axios from "axios";

export function getIndustryList(params) {
  return axios.post("/seller/2_1/getIndustryList", params).then((res) => res.data);
}
export function infoTwo(params) {
  return axios
    .post("/store/InfoTwo", params, {
      headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
    })
    .then((res) => res.data);
}
export function getCode(params) {
  return axios.get("/phone/verificationCode", { params }).then((res) => res.data);
}
export function share(params) {
  return axios.post("/buyer/2_1/share/app", params).then((res) => res.data);
}
export function myAssess(params) {
  return axios.post("/buyer/2_1/evaluate/my", params).then((res) => res.data);
}
// 2.5.1获取骑手位置信息（高斯凌）
export function getOrderRiderInfo(params) {
  return axios.post("/rider/2_1/getOrderRiderInfo", params).then((res) => res.data);
}
// 2.5.4新人大礼包（王冬冬)
export function getNewshare(params) {
  return axios.post("/buyer/2_1/couponPackage/new", params).then((res) => res.data);
}
// 2.7.0卖家获取 分享商品支出金额明细（王冬冬)
export function shareList(params) {
  return axios.post("/seller/2_1/cs/wallet/shareList", params).then((res) => res.data);
}
// 2.7.0卖家获取 分享商品合计支出金额（王冬冬）
export function sumOutMoney(params) {
  return axios.post("/seller/2_1/cs/wallet/sumOutMoney", params).then((res) => res.data);
}


